import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EcommerceCommonUISharedModule } from './extensions/87d9badd20dea844ca7227e4a924a938b908d0e4d168a26aa8c8f3804e338133/ecommerce-common-ui-shared.module';
import { EcommerceCommonPipeSharedModule } from './extensions/87d9badd20dea844ca7227e4a924a938b908d0e4d168a26aa8c8f3804e338133/ecommerce-common-pipe-shared.module';
import { AfterSaleUiSharedModule } from './extensions/095f7e13f44ad6cd8c73f9a962f8c599c7fcfe4bf98f607fb0fb1afb98380302/after-sale-ui-shared.module';


@NgModule({
    imports: [CommonModule, EcommerceCommonUISharedModule, EcommerceCommonPipeSharedModule, AfterSaleUiSharedModule],
})
export class SharedExtensionsModule {}
